import HARDCODE from '../../../business-const/HardCode/HardCode'

import MESSAGE from '../../../business-const/Message/Message'

import {
    formataCpf,
} from '../../../business-components/Formata/Formata'

import {
    pesquisaList,
    pesquisaDescricaoList,
    pesquisaIdList,
} from '../../../business-rules/List/ListService'

import seguradoraList from '../../../business-rules/List/SeguroVida/seguradoraList'

import {
    indexAtualJsonRegistros,
    obtemDadoXLSX,
    timeSeguradora,
    idAgenteTimeSeguradora,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
} from './IntegracaoClienteArquivoService'



export const importaListaTransferenciaClientesOutras = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)


    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            const nomeArquivoLinha = nomeArquivo + ' - ' + (linha + 1)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 0,
                HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivoLinha)

            const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][1])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

           
            
            if (usuarioClienteSelecionado) {
            
                jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
    
            } else {
        
                erros.push(MESSAGE().agenteNaoEncontradoCpfSeguradoCliente
                    .replace("$cpfSeguradoCliente$", formataCpf(jsonRegistros.jsonRegistros[indexJsonRegistros].cpfSeguradoCliente))
                        .replace("$codigoAgente$", XLSX[linha][1])
                )
            }

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }

    return jsonRegistros.jsonRegistros
}



export const importaListaClientesAgentesOutras = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            const nomeArquivoLinha = nomeArquivo + ' - ' + (linha + 1)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 0, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivoLinha)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivoLinha)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 2, HARDCODE.importacaoInstituicaoFinanceira, true, null, erros, nomeArquivoLinha)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoNumeroConta, false, null, erros, nomeArquivoLinha)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoCodigoAgente, true, null, erros, nomeArquivoLinha)
            
            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++

    }

    return jsonRegistros.jsonRegistros
}



const calculaCorretorSeguros = (timeSeguradoraAux, corretorSeguros, erros, numeroApolice) => {

    if (corretorSeguros) {

        const corretorSegurosAux = idAgenteTimeSeguradora(timeSeguradoraAux, corretorSeguros)

        if (!corretorSegurosAux) {

            erros.push(MESSAGE().agenteNaoEncontradoApolice
                .replace("$numeroApolice$", numeroApolice)
                    .replace("$codigoAgente$", corretorSeguros)
            )
        }

        corretorSeguros = corretorSegurosAux
    }

    return corretorSeguros
}

export const importaListaApolicesAgentesOutras = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)


    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            const nomeArquivoLinha = nomeArquivo + ' - ' + (linha + 1)

            const seguradora = XLSX[linha][0]

            let idSeguradora = pesquisaList(seguradoraList(), seguradora).id

            if (!idSeguradora) {

                idSeguradora = pesquisaIdList(seguradoraList(), seguradora)
            }

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 1,
                HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivoLinha)

            if (idSeguradora) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].seguradora = idSeguradora

                jsonRegistros.jsonRegistros[indexJsonRegistros].seguradoraDescricao =
                    pesquisaDescricaoList(seguradoraList(), idSeguradora)

                jsonRegistros.jsonRegistros[indexJsonRegistros].idCorretorSeguros = 
                    calculaCorretorSeguros(timeSeguradoraAux, XLSX[linha][2], erros,
                        jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoPercDivisaoComissao,
                    false, null, erros, nomeArquivo)

                jsonRegistros.jsonRegistros[indexJsonRegistros].idCorretorSeguros2 = 
                    calculaCorretorSeguros(timeSeguradoraAux, XLSX[linha][4], erros,
                        jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 5, HARDCODE.importacaoCodigoAgente,
                    false, null, erros, nomeArquivoLinha)

                if (
                        jsonRegistros.jsonRegistros[indexJsonRegistros].idCorretorSeguros2 &&
                        !jsonRegistros.jsonRegistros[indexJsonRegistros].percDivisaoComissao
                ) {

                     erros.push(MESSAGE().percDivisaoComissaoCorretorSeguros2Apolice
                        .replace("$numeroApolice$",
                            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
                    )
                }

            } else {

                    erros.push(MESSAGE().seguradoraNaoEncontradaApolice
                        .replace("$numeroApolice$",
                            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
                                .replace("$seguradora$", seguradora)
                )
            }

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }

    return jsonRegistros.jsonRegistros
}



export const importaParcelas = (values, item, linhaIntegracaoCotacao, XLSX) => {

    let linha = linhaIntegracaoCotacao.cabecalho + 1

    values.parcelasImportadas = []

    while (linha < XLSX.length) {

        const valor = XLSX[linha][0] ? XLSX[linha][0] : 0

        //if (XLSX[linha][0]) {

            values.parcelasImportadas.push(valor/*XLSX[linha][0]*/)
        //}

        linha++
    }
}